import React from 'react';
import { Chart as ChartJS, BarElement, CategoryScale, LinearScale, PointElement, LineElement, Tooltip, Legend } from 'chart.js';
import { Bar } from 'react-chartjs-2';

// Register required components
ChartJS.register(
  BarElement,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend
);

const BarChart = ({ AnalyticsData }) => {
  // Backend returns TotalVisits/TotalChats as a single object keyed by month label
  // (e.g. { Jan: 5, Feb: 0, ... }). Build one shared label set so the Visits bars
  // and the Chats line always line up against the same months.
  const visits = AnalyticsData?.TotalVisits?.length > 0 ? AnalyticsData.TotalVisits[0] : {};
  const chats = AnalyticsData?.TotalChats?.length > 0 ? AnalyticsData.TotalChats[0] : {};

  const mergedKeys = Array.from(new Set([...Object.keys(visits), ...Object.keys(chats)]));
  const hasData = mergedKeys.length > 0;

  const allKeys = hasData ? mergedKeys : ['There is no Data Currently'];
  const allValues = hasData ? mergedKeys.map((k) => visits[k] ?? 0) : [0];
  const allChatValues = hasData ? mergedKeys.map((k) => chats[k] ?? 0) : [0];

  const data = {
    labels: allKeys,
    datasets: [
      {
        label: 'Visits',
        data: allValues,
        backgroundColor: 'rgba(54, 162, 235, 1)',
        borderColor: 'rgba(54, 162, 235, 1)',
        borderWidth: 2,
        order: 1,
      },
      {
        label: 'Chats',
        type: 'line',
        data: allChatValues,
        borderColor: 'rgba(53, 96, 100, 1)',
        backgroundColor: 'rgba(53, 96, 100, 1)',
        order: 0,
      },
    ],
  };

  // Chart options
  const options = {
    responsive: true,
    maintainAspectRatio: false, // Allows the canvas to grow with its container
    scales: {
      y: {
        beginAtZero: true,
      },
    },
  };

  return (

    <div style={{ display: "flex", justifyContent: "center", alignItems: "end", height: 410 }}>
      <Bar data={data} options={options} />
    </div>

  );
};

export default BarChart;
